import { IconMarkers } from '../iconBuilder';

export const GOOGLE_MARKER: IconMarkers = {
    color: '',
    path: '',
    svg: `<svg
        width="40"
        height="36"
        viewBox="0 0 22.5 18"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18 9.21583C18 8.608 17.94 7.98056 17.84 7.39233H9.17755V10.8629H14.1389C13.9389 11.9805 13.2787 12.9609 12.2984 13.5883L15.2592 15.8432C16.9997 14.2549 18 11.9413 18 9.21583Z"
            fill="#4280EF"
        />
        <path
            d="M9.17754 17.9999C11.6582 17.9999 13.7388 17.196 15.2592 15.8235L12.2984 13.5882C11.4782 14.1372 10.4179 14.4509 9.17754 14.4509C6.77688 14.4509 4.75632 12.8627 4.01611 10.7451L0.975266 13.0392C2.5357 16.0783 5.69658 17.9999 9.17754 17.9999Z"
            fill="#34A353"
        />
        <path
            d="M4.01611 10.7255C3.63601 9.60791 3.63601 8.39224 4.01611 7.27462L0.975271 4.96094C-0.32509 7.50991 -0.32509 10.5099 0.975271 13.0392L4.01611 10.7255Z"
            fill="#F6B704"
        />
        <path
            d="M9.17754 3.5689C10.4779 3.54929 11.7583 4.03948 12.6985 4.92182L15.3193 2.33363C13.6588 0.804248 11.4582 -0.0192653 9.17754 0.000342207C5.69658 0.000342207 2.5357 1.92187 0.975266 4.96103L4.01611 7.27471C4.75632 5.1375 6.77688 3.5689 9.17754 3.5689Z"
            fill="#E54335"
        />
    </svg>`,
};
